import React from 'react'
import { useSlsHighlightsContext, useSlsStateContext } from '@fs/zion-sls'
import { useOverlay } from '@fs/zion-ui'
import HighlightPanel from '../highlightPanel/HighlightPanel'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'
import { checkIfSharedHighlights } from './utils/utils'
import { useR2DispatchContext, useR2StateContext } from '../../../../providers/r2Provider/R2Context'
import SharedHighlightOverlay from '../../overlays/SharedHighlightOverlay'
import SharedHighlightPanel from '../sharedHighlightPanel/SharedHighlightPanel'

const HighlightPanelsContainer = ({ onSave: onSaveProp, onCancel, splitScreenImageArk, saveToSls }) => {
  const { activeFieldInfo, setCreatingRects, setEditMode, setActiveFieldInfo } = useSlsHighlightsContext()
  const { closeOverlay } = useOverlayContext()
  const zionSlsState = useSlsStateContext()
  const r2State = useR2StateContext()
  const r2Dispatch = useR2DispatchContext()
  const warningOverlay = useOverlay()

  const saveHighlightsPanelData = (data) => {
    const {
      mainEditHighlights,
      splitScreenEditHighlights,
      mainSelectedHighlights,
      splitScreenSelectedHighlights,
      fieldType,
    } = data

    // Disabling highlight creation and edit mode when saving
    setCreatingRects(false)
    setEditMode(false)

    // Detect linked highlights
    const hasLinkedHighlights = checkIfSharedHighlights({
      mainSelectedHighlights,
      splitScreenSelectedHighlights,
      fieldType: fieldType?.fieldType || activeFieldInfo?.fieldType,
      types: zionSlsState.types,
      personId: r2State?.selectedPersonId || activeFieldInfo?.personId,
    })

    if (hasLinkedHighlights) {
      r2Dispatch({
        type: 'BATCH_DISPATCHES',
        value: [
          {
            type: 'SET_EDIT_HIGHLIGHTS',
            value: mainEditHighlights,
          },
          {
            type: 'SET_REFERENCE_EDIT_HIGHLIGHTS',
            value: splitScreenEditHighlights,
          },
          {
            type: 'SET_HIGHLIGHTS_FIELD_INFO',
            value: activeFieldInfo,
          },
          {
            type: 'SET_SELECTED_HIGHLIGHTS',
            value: { main: mainSelectedHighlights, splitScreen: splitScreenSelectedHighlights },
          },
        ],
      })

      warningOverlay.open()
    } else {
      setActiveFieldInfo({ id: null, value: null })
      closeOverlay('highlightsPanel')
      onSaveProp?.(data)
    }
  }

  const saveSharedHighlightPanelData = (data) => {
    // Disabling highlight creation and edit mode when saving
    setCreatingRects(false)
    setEditMode(false)
    onSaveProp?.(data)
  }

  return (
    <>
      <HighlightPanel onSave={saveHighlightsPanelData} onCancel={onCancel} splitScreenImageArk={splitScreenImageArk} />
      <SharedHighlightOverlay overlay={warningOverlay} />
      <SharedHighlightPanel onSave={saveSharedHighlightPanelData} saveToSls={saveToSls} />
    </>
  )
}

export default HighlightPanelsContainer
